export default defineNuxtRouteMiddleware(async (to: any) => {
  const { vip, clubvip, gamification } = to.query;

  if (!vip && !clubvip && !gamification) {
    return;
  }

  const { t } = useTexts();
  const { goToLocaleRoute } = useRoutes();

  const { isReadySmartico } = storeToRefs(useSmarticoInit());
  const { runAction } = useSmarticoInit();
  const { isAuthenticated } = storeToRefs(useAuthStore());
  const { openToaster } = useLayoutStore();
  const { openLogin } = useAuth();

  async function goToHomePage() {
    return await goToLocaleRoute({
      name: 'index',
      replace: true,
    });
  }

  if (!isAuthenticated.value) {
    openLogin();

    return await goToHomePage();
  }

  if (!isReadySmartico.value) {
    openToaster({
      message: t('gamefication.loading'),
      type: 'info',
    });

    return await goToHomePage();
  }

  runAction('dp:gf_tournaments');

  return await goToHomePage();
});
